import {
    Button,
    Form,
    Modal,
    Segmented,
    Select,
    Row,
    Col,
    DatePicker,
    message,
    Grid,
} from "antd";
import React, { useEffect, useState } from "react";
import {
    useSingleItem,
    useItemsFine,
    useCreateItemMutation,
} from "../_actions/app/items";
import { useRandomTemplate } from "../actions/app/items";
import { PresetInputForm } from "../qmade/creator/TemplateAIInput";
import { useAddEvent } from "../_actions/bot";
import log from "cslog";
import dayjs from "dayjs";
import { ArrowRightOutlined } from "@ant-design/icons";
import TokenManagerModal from "../finance/TokenManagerModal";
import Handlebars from "handlebars";
import Loading from "../common/Loading";

const EVENT_TYPES = {
    birthday: {
        label: "Birthday",
        type: "preset",
        data: {
            preset_id: "1031fc88-048b-4258-b615-53bfad6c6bb9",
        },
        options: [
            {
                label: "Without Photo",
                value: "without_photo",
                payload: {
                    preset_id: "b7845397-87f2-48d0-aa7c-5ce37261f34b",
                },
            },
            {
                label: "With Photo",
                value: "with_photo",
                payload: {
                    preset_id: "1031fc88-048b-4258-b615-53bfad6c6bb9",
                },
            },
            {
                label: "With 2 Photos",
                value: "with_2_photo",
                payload: {
                    preset_id: "fc88bedb-b138-4f17-a3d1-fc5137b1d165",
                },
            },
        ],
    },
    wedding_anniversary: {
        label: "Wedding Anniversary",
        type: "preset",
        data: {
            preset_id: "eb886ca6-8906-4d3a-ad31-fa3c6eaa5e6e",
        },
        options: [
            {
                label: "Without Photo",
                value: "without_photo",
                payload: {
                    preset_id: "eb886ca6-8906-4d3a-ad31-fa3c6eaa5e6e",
                },
            },
            {
                label: "With Photo",
                value: "with_photo",
                payload: {
                    preset_id: "d195d84e-da7d-4ad0-b0af-ed2159a5760c",
                },
            },
        ],
    },
    announcement: {
        label: "Announcement",
        type: "preset",
    },
    customer_feedback: {
        label: "Customer Feedback",
        type: "preset",
        options: [
            {
                label: "Without Photo",
                value: "without_photo",
                payload: {
                    preset_id: "b7845397-87f2-48d0-aa7c-5ce37261f34b",
                },
            },
            {
                label: "With Photo",
                value: "with_photo",
                payload: {
                    preset_id: "1031fc88-048b-4258-b615-53bfad6c6bb9",
                },
            },
        ],
    },
};

const AddEventModal = ({ trigger, org, initialDate, onAdded }) => {
    // modal visible only when trigger is provided
    const [open, setOpen] = useState(false);
    const { useBreakpoint } = Grid;
    const screens = useBreakpoint();
    const isMobile = !screens.sm;

    const [selected_event_type, setSelectedEventType] = useState(null);
    const [eventDate, setEventDate] = useState(
        initialDate ? dayjs(initialDate) : null
    );
    const [user_inputs, setUserInputs] = useState({});
    const [extra, setExtra] = useState({});
    const [calendarEntry, setcalendarEntry] = useState(null);
    const [openTokenModal, setOpenTokenModal] = useState(false);

    const {
        isSuccess,
        isLoading,
        data: categoryData,
    } = useItemsFine("qdb_creation_category", "fields=*,presets.*", true);
    console.log("org in add event modal", org);

    const mutationEvent = useAddEvent(
        (result) => {
            log.d(result, "Event entry Result");
            if (result?.success === true) {
                setcalendarEntry(result?.data);
                if (trigger) setOpen(false);
                message.success("Event added successfully");
                if (typeof onAdded === "function") onAdded(result?.data);
            }
            if (
                result?.success === false &&
                result?.error?.code === "TOKEN_INSUFFICIENT"
            ) {
                setOpen(false);
                message.error(result?.error?.msg);
                setOpenTokenModal(true);
            }
        },
        (error) => {
            log.e(error, "event addition failed");
            const errorMessage =
                error?.response?.data?.detail ||
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                error?.message ||
                "Failed to add event. Please try again.";
            message.error(errorMessage);
        }
    );

    // keep eventDate in sync with initialDate
    useEffect(() => {
        setEventDate(initialDate ? dayjs(initialDate) : null);
    }, [initialDate]);

    const createEvent = () => {
        if (!eventDate) {
            message.error("Please enter the event date");
            return;
        }
        if (!user_inputs || Object.keys(user_inputs).length === 0) {
            message.error("Please enter the required inputs");
            return;
        }
        const formattedDate = eventDate ? eventDate.format("YYYY-MM-DD") : null;

        const dynamic_name_template = extra.dynamic_name || "";
        // fill value from user_inputs using Handlebars
        let dynamic_name = dynamic_name_template;
        try {
            const template = Handlebars.compile(dynamic_name_template);
            dynamic_name = template(user_inputs);
        } catch (error) {
            log.e(error, "Handlebars compilation error");
        }

        const eventPayload = {
            event_type: selectedCategory?.name,
            date: formattedDate,
            preset_id: extra.preset_id,
            user_inputs: user_inputs,
            name: dynamic_name,
        };
        log.d(eventPayload, "Creating event with");
        mutationEvent.mutate(eventPayload);
        log.d(calendarEntry, "calendar event entry");
    };

    const selectedCategory = Array.isArray(categoryData)
        ? categoryData.find(
              (item) =>
                  item.id === selected_event_type ||
                  item.key === selected_event_type
          )
        : null;

    // shared form content
    const FormContent = (
        <>
            <Form layout="vertical">
                <Row gutter={16}>
                    <Col xs={24} md={12}>
                        <Form.Item label="Event type">
                            <Select
                                placeholder="Select event type"
                                style={{ width: "100%" }}
                                options={
                                    Array.isArray(categoryData)
                                        ? categoryData.map((item) => ({
                                              value: item.id,
                                              label: item.name,
                                          }))
                                        : []
                                }
                                value={selected_event_type}
                                onChange={(val) => setSelectedEventType(val)}
                            />
                        </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                        <Form.Item label="Event date">
                            <DatePicker
                                style={{ width: "100%" }}
                                value={eventDate}
                                onChange={(date) => setEventDate(date)}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>

            {selected_event_type && selectedCategory && (
                <RenderEventForm
                    key={selected_event_type}
                    category={selectedCategory}
                    setValues={setUserInputs}
                    setExtra={setExtra}
                />
            )}
        </>
    );

    // inline mode (no trigger): render the form directly with its own action button
    if (!trigger) {
        return (
            <div>
                {FormContent}
                <div style={{ marginTop: 16, textAlign: "left" }}>
                    <Button
                        type="primary"
                        onClick={createEvent}
                        loading={mutationEvent.isLoading}
                        icon={<ArrowRightOutlined />}
                        iconPosition="end"
                        size={isMobile ? "large" : "middle"}
                        block={isMobile}
                    >
                        {mutationEvent.isLoading
                            ? "Generating..."
                            : "Add Event"}
                    </Button>
                </div>
            </div>
        );
    }

    // modal mode (trigger provided)
    return (
        <>
            <div onClick={() => setOpen(true)}>{trigger}</div>
            <Modal
                title="Add New Event"
                closable={true}
                open={open}
                onOk={createEvent}
                onCancel={() => setOpen(false)}
                okText={mutationEvent.isLoading ? "Generating..." : "Add Event"}
                confirmLoading={mutationEvent.isLoading}
                width={isMobile ? "100%" : undefined}
                okButtonProps={{ size: isMobile ? "large" : "middle" }}
                cancelButtonProps={{ size: isMobile ? "large" : "middle" }}
            >
                {FormContent}
            </Modal>
            <TokenManagerModal
                selected_org={org}
                open={openTokenModal}
                onClose={() => setOpenTokenModal(false)}
            />
        </>
    );
};

export default AddEventModal;

function RenderEventForm({ category, setValues, setExtra }) {
    const [selectedPreset, setSelectedPreset] = useState(
        category.presets && category.presets.length > 0
            ? category.presets[0]
            : null
    );

    return (
        <div>
            {category.presets && category.presets.length > 0 && (
                <Segmented
                    options={category.presets.map((preset) => ({
                        label: preset.name,
                        value: preset.id,
                    }))}
                    onChange={(val) => {
                        const preset = category.presets.find(
                            (p) => p.id === val
                        );
                        setSelectedPreset(preset);
                        setExtra({
                            preset_id: preset.qdb_creation_schema_id,
                            category_id: category.id,
                        });
                    }}
                />
            )}
            {/* <pre>{JSON.stringify(payload, null, 2)}</pre> */}
            {selectedPreset && (
                <EventFormPreset
                    preset_id={selectedPreset.qdb_creation_schema_id}
                    setValues={setValues}
                    setExtra={setExtra}
                />
            )}
        </div>
    );
}

function EventFormPreset({ preset_id, setValues, setExtra }) {
    const { isLoading, isSuccess, data } = useSingleItem(
        "qdb_creation_schema",
        `/${preset_id}`,
        !!preset_id
    );

    useEffect(() => {
        if (isSuccess) {
            setExtra({
                preset_id: preset_id,
                // schema: data,
                block_id: data?.block_id,
                dynamic_name: data?.dynamic_name || data?.display_name,
            });
        }
    }, [isSuccess, data, preset_id, setExtra]);

    if (isLoading) return <Loading />;
    if (!isSuccess) return <p>Error</p>;

    return (
        <div>
            <PresetInputForm
                schema={data}
                onChange={(values, allValues) => {
                    // log.d(allValues, "allValues");
                    setValues(allValues);
                }}
            />
        </div>
    );
}
